// extracted by mini-css-extract-plugin
export var container = "Layout-module--container--2IpcU";
export var header = "Layout-module--header--2872K";
export var headerContainer = "Layout-module--header-container--2t9_Q";
export var mainContainer = "Layout-module--main-container--19BhK";
export var body = "Layout-module--body--2O5JF";
export var footer = "Layout-module--footer--3r6XS";